module.exports = require("string_decoder");


//////////////////
// WEBPACK FOOTER
// external "string_decoder"
// module id = 172
// module chunks = 0